module.exports = { "default": require("core-js/library/fn/object/is"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/is.js
// module id = 695
// module chunks = 0